import { resolvePhoenixAddressesForEnv } from "@/lib/phoenix/traderAddresses";
import { getPhoenixEnv } from "@/lib/env";

/**
 * Central resolver for the Phoenix program address.
 * Driven by NEXT_PUBLIC_PHOENIX_ENV ("prod" | "beta") via resolvePhoenixAddresses.
 * All rise flight calls that accept a phoenixProgramAddress should read from here.
 */
export const phoenixProgramAddress = () =>
  resolvePhoenixAddressesForEnv().programAddress;

export const phoenixEnv = () => getPhoenixEnv();
